var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VList",
    { staticClass: "user-entries-component" },
    [
      _c(
        "VListTile",
        { attrs: { to: { name: _vm.USER_PROFILE_PAGE } } },
        [
          _c(
            "VListTileAvatar",
            [
              _c("KmIcon", {
                attrs: { color: "text", name: "km-icon-profile" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("VListTileTitle", { staticClass: "text--text" }, [
            _vm._v("\n      Profile\n    "),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "VListTile",
        { attrs: { to: { name: _vm.BUCKETS_PAGE } } },
        [
          _c(
            "VListTileAvatar",
            [
              _c("KmIcon", {
                attrs: { color: "text", name: "km-icon-buckets-list" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("VListTileTitle", { staticClass: "text--text" }, [
            _vm._v("\n      Buckets\n    "),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "VListTile",
        { staticClass: "logout-link", on: { click: _vm.logout } },
        [
          _c(
            "VListTileAvatar",
            [
              _c("KmIcon", {
                attrs: { color: "error", name: "km-icon-logout" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("VListTileTitle", { staticClass: "error--text" }, [
            _vm._v("\n      Logout\n    "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }